<template>
    <div>
        <HeaderBg :img="img" :title="$t('questions.title')" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteQuestion" 
            :messege="$t('questions.confirmDelete')"
        />
        <header class="admin_content_header">
            <div class="filter">
                <!-- <select>
                    <option value="" selected disabled>المدينة</option>
                </select> -->
            </div>
            <div class="search">
                <!-- <input type="text" placeholder="البحث برقم الفرع"> -->
            </div>
            <router-link to="/admin/questions/add-questions"> + {{ $t('questions.addQuestion') }} </router-link>
            
        </header>
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th>{{$t('questions.question')}}</th>
                        <th>{{$t('questions.answer')}}</th>
                        <th>{{$t('questions.language')}}</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="question in questions" :key="question.id">
                        <td> {{question.question}} </td>
                        <td class="wrap-text"> {{question.answer}} </td>
                        <td> {{question.locale}} </td>

                        <td>
                            <div class="block actions">
                                <div class="delete" @click="() => deleteData(question.id)">
                                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                                </div>
                                <div class="edit" @click="() => editQuestion(question.id)">
                                    <img src="../../../assets/images/editLogo.svg" alt="">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination mt-5" v-if="questions.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
import Request from '../../../services/Request';
import Alert from '../../global/Alert/Alert';

export default {
    name: 'Questions',
    components: {HeaderBg, RequestSpinner, Alert},
    data(){
        return{
            loadingRequest: true,
            img: require('../../../assets/images/saleWhite.svg'),
            questions: [],

            deleteID: '',
            alertToggle: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        this.getQuestions();
    },
    methods:{
        getQuestions(){
            Request.fetch('admin/investor_relation_questions', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.questions = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        editQuestion(id){
            this.$router.push(`/admin/questions/add-questions/${id}`)
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteQuestion(){
            Request.delete('admin/investor_relation_questions',this.deleteID)
            .then( () => {
                this.getQuestions();
            })
        },

        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getQuestions();
            } else{
                this.apiParams = `?page=${val}`;
                this.getQuestions();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
    display: block;
    &:hover{
        color: #FFF;
    }
}
.actions{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .delete,
    .edit{
        width: 40px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FF002B;
        cursor: pointer;
        svg{
            color: #FFF;
            font-size: 25px;
        }
    }
    .edit{
        background-color: #78A28F;
        margin-inline-start: 10px;
    }
}
.wrap-text{
    text-wrap: wrap;
    white-space: normal;
    word-break: break-word;
}
</style>